import { createSelector } from 'reselect';

const selectGlobalCommunity = (state: any) => state.globalCommunity;


export const selectGlobalCommunityCurrentItem = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.current);

export const selectGlobalCommunityListItems = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.list);

export const selectGlobalCommunityItemById = (itemId: any) =>
    createSelector(selectGlobalCommunityListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalCommunityCreatedItem = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.create);

export const selectGlobalCommunityUpdatedItem = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.update);

export const selectGlobalCommunityQueryItems = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.query);

export const selectGlobalCommunityReadItem = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.read);

export const selectGlobalCommunityDeletedItem = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.delete);

export const selectGlobalCommunitySearchedItems = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.search);

export const selectGlobalCommunityItemsCount = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.count);

export const selectGlobalCommunityItemsFilter = createSelector([selectGlobalCommunity], (globalCommunity) => globalCommunity.filter);